var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 89,
    viewBox: "0 0 38 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78049 88.488L18.863 9.14669",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0367 9L34.9873 88.3669",
    stroke: "white",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 0L21.6773 9.25H16.2379L19 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pinIcon.7aad62750e2154f2652fe1e4954c750c.svg";
export { ForwardRef as ReactComponent };